import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { T, useTranslate } from 'shared/helper/translate';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import { getIsPastDue, getPaddlePlanIdForCurrentPlan } from '../reducer';
import PlanManagementButton from '../plan/PlanManagementButton';

/**
 * PlanPagePaymentRecoveryBanner
 *
 * Shown only on the My Plans page when the user is in the payment recovery
 * grace period (premium.status === 'error', not trial-blocked).
 *
 * Displays: "We couldn't process your renewal payment. Please update your
 * payment method by {deadline date} to continue using Rubriq without interruption."
 *
 * Deadline date logic:
 *   - yearly plans:  startsAt + 1 month  (grace period from the failed renewal date)
 *   - monthly plans: endsAt              (existing behaviour, unchanged)
 *
 * Entirely additive — renders nothing unless isPastDue is true.
 */
var PlanPagePaymentRecoveryBanner = function PlanPagePaymentRecoveryBanner() {
  var _curiePlans$premium, _curiePlans$premium2, _curiePlans$premium3;
  var isPastDue = useSelector(getIsPastDue);
  var curiePlan = useSelector(function (_ref) {
    var curie = _ref.curie;
    return curie.plan;
  });
  var curiePlans = useSelector(function (_ref2) {
    var curie = _ref2.curie;
    return curie.plans;
  });
  var paddlePlanId = useSelector(getPaddlePlanIdForCurrentPlan);
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  if (!isPastDue || useCartInsteadOfPaddle) {
    return null;
  }
  var billingInterval = curiePlans === null || curiePlans === void 0 || (_curiePlans$premium = curiePlans.premium) === null || _curiePlans$premium === void 0 ? void 0 : _curiePlans$premium.billingInterval;
  var deadlineDate = billingInterval === 'yearly' ? moment(curiePlans === null || curiePlans === void 0 || (_curiePlans$premium2 = curiePlans.premium) === null || _curiePlans$premium2 === void 0 ? void 0 : _curiePlans$premium2.startsAt).utc().add(1, 'month') : moment(curiePlans === null || curiePlans === void 0 || (_curiePlans$premium3 = curiePlans.premium) === null || _curiePlans$premium3 === void 0 ? void 0 : _curiePlans$premium3.endsAt).utc();
  return /*#__PURE__*/React.createElement("div", {
    className: "row mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "curie.payment-recovery-banner-plan-page",
    params: {
      deadlineDay: deadlineDate.format('DD'),
      deadlineMonth: t(deadlineDate.format('MMMM')),
      deadlineYear: deadlineDate.format('YYYY')
    },
    linkRenderer: function linkRenderer(_ref3) {
      var _curiePlan$paddleSubs;
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(PlanManagementButton, {
        classicUrl: (_curiePlan$paddleSubs = curiePlan.paddleSubscription) === null || _curiePlan$paddleSubs === void 0 ? void 0 : _curiePlan$paddleSubs.updateUrl,
        targetAction: "update",
        paddlePlanId: paddlePlanId,
        asButton: false
      }, children);
    }
  })))));
};
export default PlanPagePaymentRecoveryBanner;